import { createActionCreator } from "common/ReduxUtils";
import { CreateShipmentFormState } from "../CreateShipmentState";
import { CreateShipmentFormActionTypes } from "../CreateShipmentActionTypes";

export const setPrepopulatedFormState = createActionCreator<CreateShipmentFormState>(
  CreateShipmentFormActionTypes.PREPOPULATE_FORM,
  "formState"
);
